import { Component, OnChanges, OnDestroy, AfterViewInit, ChangeDetectorRef, SimpleChanges, ViewChild, ElementRef } from '@angular/core';
import { EventEmitter, Output, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-time-picker',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './time-picker.component.html',
  styleUrl: './time-picker.component.css'
})
  
export class TimePickerComponent implements OnChanges, OnDestroy, AfterViewInit {
  @Output() timeChange = new EventEmitter<{type: string, hour: string, minute: string, formatted: string}>();
  @Input() type: 'start' | 'end' = 'start';
  @Input() hour: number | string = '';
  @Input() minute: number | string = '';
  @Input() invalid = false;
  @Input() tabIndex: number | null = null;

  hourValue: string = '';
  minuteValue: string = '';

  @ViewChild('hourInput')    hourInputRef!:  ElementRef<HTMLInputElement>;
  @ViewChild('minuteInput')  minuteInputRef!: ElementRef<HTMLInputElement>;
  @ViewChild('hourUpBtn')    hourUpBtnRef!:   ElementRef<HTMLButtonElement>;
  @ViewChild('hourDownBtn')  hourDownBtnRef!: ElementRef<HTMLButtonElement>;
  @ViewChild('minUpBtn')     minUpBtnRef!:    ElementRef<HTMLButtonElement>;
  @ViewChild('minDownBtn')   minDownBtnRef!:  ElementRef<HTMLButtonElement>;

  private pressTimer: ReturnType<typeof setTimeout> | null = null;
  private repeatInterval: ReturnType<typeof setInterval> | null = null;
  /** touchstart 直後のマウスイベント二重発火を防ぐためのタイムスタンプ */
  private lastTouchTime = 0;

  constructor(private cdr: ChangeDetectorRef) { }

  ngAfterViewInit() {
    // touchstart をパッシブリスナーとして手動登録することで
    // "scroll-blocking event" の警告を解消する
    const btns = [
      this.hourUpBtnRef, this.hourDownBtnRef,
      this.minUpBtnRef,  this.minDownBtnRef,
    ];
    btns.forEach(btnRef => {
      const el = btnRef.nativeElement;
      el.addEventListener('touchstart',  (e: TouchEvent) => this.startPress(e), { passive: true });
      el.addEventListener('touchend',    () => this.stopPress(),                 { passive: true });
      el.addEventListener('touchcancel', () => this.stopPress(),                 { passive: true });
    });
  }

  /** 親コンポーネントから直接値を強制セット。DOM も直接書き換えるため CD/ngModel に依存しない */
  public forceDisplay(hour: any, minute: any): void {
    this.hourValue   = (hour   === '' || hour   === null || hour   === undefined) ? '' : String(hour);
    this.minuteValue = (minute === '' || minute === null || minute === undefined) ? '' : String(minute);
    // Angular の変更検知を完全にバイパスして DOM を直接更新
    if (this.hourInputRef?.nativeElement) {
      this.hourInputRef.nativeElement.value = this.hourValue;
    }
    if (this.minuteInputRef?.nativeElement) {
      this.minuteInputRef.nativeElement.value = this.minuteValue;
    }
  }
  
  ngOnChanges(changes: SimpleChanges) {
    if (changes['hour']) {
    const val = changes['hour'].currentValue;

    this.hourValue =
        val === '' || val === null || val === undefined
          ? ''
          : String(val);
    }
    if (changes['minute']) {
      const val = changes['minute'].currentValue;

      this.minuteValue =
        val === '' || val === null || val === undefined
          ? ''
          : String(val);
    }
    // if (changes['hour'] && changes['hour'].currentValue != null) {
    //   this.hourValue = String(changes['hour'].currentValue).padStart(2, '0');
    // }
    // if (changes['minute'] && changes['minute'].currentValue != null) {
    //   this.minuteValue = String(changes['minute'].currentValue).padStart(2, '0');
    // }
  }

  public emitTime() {
  //   if (this.hourValue === '' || this.minuteValue === '' || this.hourValue == null || this.minuteValue == null) {
  //   this.timeChange.emit({
  //     type: this.type,
  //     hour: '',
  //     minute: '',
  //     formatted: ''
  //   });
  //   return;
  // }
  //   const h = this.hourValue.padStart(2, '0');
  //   const m = this.minuteValue.padStart(2, '0');
    //   this.timeChange.emit({ type: this.type, hour: h, minute: m, formatted: `${h}:${m}` });
    if (!this.hourValue && !this.minuteValue) {
      this.timeChange.emit({
        type: this.type,
        hour: '',
        minute: '',
        formatted: ''
      });
      return;
    }

    // Emit raw hour/minute values (no immediate padding) so parent
    // does not overwrite the user's in-progress input with padded values.
    // Provide `formatted` with zero-padded output for display/storage.
    const rawHour = this.hourValue || '';
    const rawMinute = this.minuteValue || '';

    const m = rawMinute.padStart(2, '0');

    this.timeChange.emit({
      type: this.type,
      hour: rawHour,
      minute: rawMinute,
      formatted: `${rawHour}:${m}`
    });
  }
  
  calculateTime(event: any) {
    
    const button = event.currentTarget || event.target;
    const targetId = (button as HTMLElement).dataset['target'];
    if (!targetId) return;
    // console.log(targetId)
    const isMinute = targetId.includes('minute');
    let val = isMinute ? parseInt(this.minuteValue, 10) : parseInt(this.hourValue, 10);
    if (isNaN(val)) val = 0;

    if ((button as HTMLElement).classList.contains('up-btn')) val++;
    else if ((button as HTMLElement).classList.contains('down-btn')) val--;

    if (isMinute) {
      if (val > 59) val = 0;
      if (val < 0) val = 59;
      this.minuteValue = String(val).padStart(2, '0');
    } else {
      const maxHour = this.type === 'start' ? 23 : 47;
      if (val > maxHour) val = 0;
      if (val < 0) val = maxHour;
      this.hourValue = String(val);
    }

    this.emitTime();
    
  }

  allowOnlyNumbers(event: KeyboardEvent) {
    const allowedKeys = [
      'Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'
    ];

    if (allowedKeys.includes(event.key)) return;

    if (!/^\d$/.test(event.key)) {
      event.preventDefault();
      return;
    }

     const input = event.target as HTMLInputElement;

    // block if already 2 digits selected fully NOT replaced
    if (
      input.value.length >= 2 &&
      input.selectionStart === input.selectionEnd
    ) {
      event.preventDefault();
    }
  }

  onHourInput() {
    if (this.hourValue === '') {
      this.emitTime();
      return;
    }

    let val = parseInt(this.hourValue, 10);
    if (isNaN(val)) {
      this.hourValue = '';
      return;
    }

    const maxHour = this.type === 'start' ? 23 : 47;

    if (val > maxHour) val = maxHour;
    if (val < 0) val = 0;

    this.hourValue = val.toString();
    // this.hourValue = String(val);
    this.emitTime();
  }
  
  onMinuteInput() {
    if (this.minuteValue === '') {
      this.emitTime();
      return;
    }

    let val = parseInt(this.minuteValue, 10);
    if (isNaN(val)) {
      this.minuteValue = '';
      return;
    }

    if (val > 59) val = 59;
    if (val < 0) val = 0;

    this.minuteValue = val.toString();
    // this.minuteValue = String(val);
    this.emitTime();
  }

  startPress(event: MouseEvent | TouchEvent) {
    // タッチ直後の合成 mousedown による二重発火を防ぐ
    if (event instanceof MouseEvent) {
      if (Date.now() - this.lastTouchTime < 600) return;
    } else {
      this.lastTouchTime = Date.now();
    }
    // パッシブリスナーなので preventDefault() は呼ばない
    this.calculateTime(event);
    this.pressTimer = setTimeout(() => {
      this.repeatInterval = setInterval(() => {
        this.calculateTime(event);
      }, 80);
    }, 400);
  }

  stopPress() {
    if (this.pressTimer !== null) {
      clearTimeout(this.pressTimer);
      this.pressTimer = null;
    }
    if (this.repeatInterval !== null) {
      clearInterval(this.repeatInterval);
      this.repeatInterval = null;
    }
  }

  ngOnDestroy() {
    this.stopPress();
  }

  selectAll(event: FocusEvent) {
    const input = event.target as HTMLInputElement;

    // small timeout ensures selection after Angular focus cycle
    setTimeout(() => {
      input.select();
    });
  }
}